import React, { Component } from 'react';
import { ApolloProvider, Query } from "react-apollo";
import { mutationCreateTenant, mutationUpdateTenant, mutationBulkImport, queryGetTenantList, deleteTenant, insertMessage, userGroupSync, changeEncryptionKey, checkCustomKeyVault, checkMaxRetentionTimeSettings, createCustomKeySecret, deleteTenantMetadataQuery, queryGetAWSRegions, checkS3StorageConnection, createAsymmetricKey, getStorageData } from "../../../queries/querySettings";
import { Dropdown, DropdownMenuItemType, IDropdownStyles, IDropdownOption } from 'office-ui-fabric-react/lib/Dropdown';
import { queryGetRuleData } from "../../../queries/querySettings";
import { DatePicker } from 'office-ui-fabric-react/lib/DatePicker';

import Utils from "./../../common/Utils";

import {
    DefaultButton,
    PrimaryButton,
    Stack,
    TextField,
    ComboBox,
    Checkbox,
    Spinner,
    Panel,
    PanelType,
    Label,
    Text,
    SpinButton,
    ChoiceGroup,
    Modal,
    IconButton,
    TeachingBubble
} from "office-ui-fabric-react";
import { toast } from "react-toastify";
import { MyContext } from '../../../context';
import ExportConfig from './ExportConfig';
import ImportConfig from './ImportConfig';
import AudioStorageConfig from './AudioStorageConfig';
import BotOnboardingConfig from './BotOnboardingConfig';
import "../fabric-icons-inline.css";
import { Button } from '@fluentui/react';
import { text } from 'react-dom-factories';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';


const dropdownStyles: Partial<IDropdownStyles> = {
    dropdown: { width: 250 }
};
const contentStyles = mergeStyleSets({
    container: {
        display: 'flex',
        flexFlow: 'column nowrap',
        alignItems: 'stretch',
    },
    header: [
        {
            flex: '1 1 auto',
            borderTop: '4px solid blue',
            // color: theme.palette.neutralPrimary,
            display: 'flex',
            // fontSize: FontSizes.xLarge,
            alignItems: 'center',
            // fontWeight: FontWeights.semibold,
            padding: '12px 12px 14px 24px',
        },
    ],
    body: {
        flex: '4 4 auto',
        padding: '0 24px 24px 24px',
        overflowY: 'hidden',
        selectors: {
            p: {
                margin: '14px 0',
            },
            'p:first-child': {
                marginTop: 0,
            },
            'p:last-child': {
                marginBottom: 0,
            },
        },
    },
});

const iconButtonStyles = mergeStyleSets({
    root: {
        marginLeft: 'auto',
        marginTop: '4px',
        marginRight: '2px',
    }
});

export default class AddTenantMitel extends React.Component {

    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.openExportSettings = this.openExportSettings.bind(this);
        this._onDismissExportPanel = this._onDismissExportPanel.bind(this);
        this._onOpenExportPanel = this._onOpenExportPanel.bind(this);

        this.openImportSettings = this.openImportSettings.bind(this);
        this._onDismissImportPanel = this._onDismissImportPanel.bind(this);
        this._onOpenImportPanel = this._onOpenImportPanel.bind(this);

        this.openAudioStorageSettings = this.openAudioStorageSettings.bind(this);
        this._onDismissAudioStoragePanel = this._onDismissAudioStoragePanel.bind(this);
        this._onOpenAudioStoragePanel = this._onOpenAudioStoragePanel.bind(this);
        this.openBotOnboardingSettings = this.openBotOnboardingSettings.bind(this);
        this._onDismissBotOnboardingPanel = this._onDismissBotOnboardingPanel.bind(this);
        this._onOpenBotOnboardingPanel = this._onOpenBotOnboardingPanel.bind(this);

        const text = <MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "keyManagement")}</>)}</MyContext.Consumer>;
        if (this.props.data != null && this.props.data !== undefined) {
            this.state = {
                name: this.props.data.name,
                adminId: this.props.data.adminId,
                tenantId: this.props.data.tenantId,
                id: this.props.data.id,
                license1: this.props.data.licenseComp != null ? this.props.data.licenseComp.bought : 0,
                license1used: this.props.data.licenseComp != null ? this.props.data.licenseComp.used : 0,
                license1id: this.props.data.licenseComp != null ? this.props.data.licenseComp.id : Utils.guidGenerator(),
                license2: this.props.data.licenseCompAna != null ? this.props.data.licenseCompAna.bought : 0,
                license2used: this.props.data.licenseCompAna != null ? this.props.data.licenseCompAna.used : 0,
                license2id: this.props.data.licenseCompAna != null ? this.props.data.licenseCompAna.id : Utils.guidGenerator(),
                license3: this.props.data.licenseSmart != null ? this.props.data.licenseSmart.bought : 0,
                license3used: this.props.data.licenseSmart != null ? this.props.data.licenseSmart.used : 0,
                license3id: this.props.data.licenseSmart != null ? this.props.data.licenseSmart.id : Utils.guidGenerator(),
                license4: this.props.data.licenseSmartAna != null ? this.props.data.licenseSmartAna.bought : 0,
                license4used: this.props.data.licenseSmartAna != null ? this.props.data.licenseSmartAna.used : 0,
                license4id: this.props.data.licenseSmartAna != null ? this.props.data.licenseSmartAna.id : Utils.guidGenerator(),
                license5: this.props.data.licenseAna != null ? this.props.data.licenseAna.bought : 0,
                license5used: this.props.data.licenseAna != null ? this.props.data.licenseAna.used : 0,
                license5id: this.props.data.licenseAna != null ? this.props.data.licenseAna.id : Utils.guidGenerator(),
                license6: this.props.data.licenseCompVoice != null ? this.props.data.licenseCompVoice.bought : 0,
                license6used: this.props.data.licenseCompVoice != null ? this.props.data.licenseCompVoice.used : 0,
                license6id: this.props.data.licenseCompVoice != null ? this.props.data.licenseCompVoice.id : Utils.guidGenerator(),
                license7: this.props.data.licenseCompVoiceAna != null ? this.props.data.licenseCompVoiceAna.bought : 0,
                license7used: this.props.data.licenseCompVoiceAna != null ? this.props.data.licenseCompVoiceAna.used : 0,
                license7id: this.props.data.licenseCompVoiceAna != null ? this.props.data.licenseCompVoiceAna.id : Utils.guidGenerator(),
                license8: this.props.data.licenseSmartVoice != null ? this.props.data.licenseSmartVoice.bought : 0,
                license8used: this.props.data.licenseSmartVoice != null ? this.props.data.licenseSmartVoice.used : 0,
                license8id: this.props.data.licenseSmartVoice != null ? this.props.data.licenseSmartVoice.id : Utils.guidGenerator(),
                license9: this.props.data.licenseSmartVoiceAna != null ? this.props.data.licenseSmartVoiceAna.bought : 0,
                license9used: this.props.data.licenseSmartVoiceAna != null ? this.props.data.licenseSmartVoiceAna.used : 0,
                license9id: this.props.data.licenseSmartVoiceAna != null ? this.props.data.licenseSmartVoiceAna.id : Utils.guidGenerator(),
                license10: this.props.data.licenseRecordingInsinghtsAI != null ? this.props.data.licenseRecordingInsinghtsAI.bought : 0,
                license10used: this.props.data.licenseRecordingInsinghtsAI != null ? this.props.data.licenseRecordingInsinghtsAI.used : 0,
                license10id: this.props.data.licenseRecordingInsinghtsAI != null ? this.props.data.licenseRecordingInsinghtsAI.id : Utils.guidGenerator(),
                license11: this.props.data.licenseSmartBase != null ? this.props.data.licenseSmartBase.bought : 0,
                license11used: this.props.data.licenseSmartBase != null ? this.props.data.licenseSmartBase.used : 0,
                license11id: this.props.data.licenseSmartBase != null ? this.props.data.licenseSmartBase.id : Utils.guidGenerator(),
                license12: this.props.data.licenseComplianceBase != null ? this.props.data.licenseComplianceBase.bought : 0,
                license12used: this.props.data.licenseComplianceBase != null ? this.props.data.licenseComplianceBase.used : 0,
                license12id: this.props.data.licenseComplianceBase != null ? this.props.data.licenseComplianceBase.id : Utils.guidGenerator(),
                license13: this.props.data.licenseEntryVoiceRecording != null ? this.props.data.licenseEntryVoiceRecording.bought : 0,
                license13used: this.props.data.licenseEntryVoiceRecording != null ? this.props.data.licenseEntryVoiceRecording.used : 0,
                license13id: this.props.data.licenseEntryVoiceRecording != null ? this.props.data.licenseEntryVoiceRecording.id : Utils.guidGenerator(),

                storage: this.props.data.storageId,
                oldStorage: this.props.data.storage,
                customStorage: this.props.data.customStorage,
                packageStorage: this.props.data.packageStorage != null ? this.props.data.packageStorage : 0,
                packageAnalyticsSpeech: this.props.data.packageAnalyticsSpeech != null ? this.props.data.packageAnalyticsSpeech : 0,
                packageAnalyticsTranscript: this.props.data.packageAnalyticsTranscript != null ? this.props.data.packageAnalyticsTranscript : 0,
                packageAnalyticsVideo: this.props.data.packageAnalyticsVideo != null ? this.props.data.packageAnalyticsVideo : 0,
                packageAnalyticsTranslate: this.props.data.packageAnalyticsTranslate != null ? this.props.data.packageAnalyticsTranslate : 0,
                packageAnalyticsAI: this.props.data.packageAnalyticsAI != null ? this.props.data.packageAnalyticsAI : 0,
                packageAnalyticsBatchTranscript: this.props.data.packageAnalyticsBatchTranscript != null ? this.props.data.packageAnalyticsBatchTranscript : 0,
                packageExport: this.props.data.packageExport != null ? this.props.data.packageExport : 0,
                addOnAnalytics: this.props.data.addOnAnalytics != null ? this.props.data.addOnAnalytics : 0,
                addOnAIEntry: this.props.data.addOnAIEntry != null ? this.props.data.addOnAIEntry : 0,
                addOnFullChat: this.props.data.addOnFullChat != null ? this.props.data.addOnFullChat : 0,
                addOnZoom: this.props.data.addOnZoom != null ? this.props.data.addOnZoom : 0,
                addOnGenesys: this.props.data.addOnGenesys != null ? this.props.data.addOnGenesys : 0,
                addOnRingcentral: this.props.data.addOnRingcentral != null ? this.props.data.addOnRingcentral : 0,
                addOnDynamics: this.props.data.addOnDynamics != null ? this.props.data.addOnDynamics : 0,
                addOnCompliance: this.props.data.addOnCompliance != null ? this.props.data.addOnCompliance : 0,
                addOnQualityManagement: this.props.data.addOnQualityManagement != null ? this.props.data.addOnQualityManagement : 0,
                addOnLeapXpert: this.props.data.addOnLeapXpert != null ? this.props.data.addOnLeapXpert : 0,
                addOnMsftTeamsVoice: this.props.data?.addOnMsftTeamsVoice ?? 0,
                addOnEmail: this.props.data.addOnEmail != null ? this.props.data.addOnEmail : 0,
                addOnMsftTeamsUC: this.props.data?.addOnMsftTeamsUC ?? 0,
                addOnN1Mapping: this.props.data?.addOnN1Mapping ?? 0,
                mailAlarming: this.props.data.mailAlarming != null ? this.props.data.mailAlarming : "",
                contractNumber: this.props.data.contractNumber != null ? this.props.data.contractNumber : "",
                exportType: this.props.data.exportType,
                exportStorage: this.props.data.exportStorage,
                type: this.props.data.type,
                keyManagementType: this.props.data.keyManagementType != null ? this.props.data.keyManagementType : "No",
                keySecurity: this.props.data.keyManagement != null ? this.props.data.keyManagement.keySecurity : "Aes128",
                rotationType: this.props.data.keyManagement != null ? this.props.data.keyManagement.rotationType : "Interval",
                intervalDays: this.props.data.keyManagement != null ? this.props.data.keyManagement.intervalDays : 365,
                activationDelay: this.props.data.keyManagement != null ? this.props.data.keyManagement.activationDelay : 0,
                willExpire: this.props.data.keyManagement != null ? (this.props.data.keyManagement.willExpire == "Yes" ? true : false) : false,
                expireDays: this.props.data.keyManagement != null ? this.props.data.keyManagement.expireDays : 0,
                customEncryptionKeyVaultUrl: this.props.data.keyManagement != null ? this.props.data.keyManagement.customEncryptionKeyVaultUrl : "",
                customEncryptionKeySecretName: this.props.data.keyManagement != null ? this.props.data.keyManagement.customEncryptionKeySecretName : "",
                manualCreationCustom: false,
                manualCreationKeyRotation: false,
                isChanged: false,
                bulkImport: false,
                bulkLicense: "0",
                bulkRuleRecording: "",
                bulkRuleReplay: "",
                bulkRuleAccess: "",
                bulkRuleAnalytics: "",
                bulkUserList: "",
                bulkImportText: "",
                deleteTenantText: "",
                deleteTenant: "",
                deleteTenantMetadataText: "",
                deleteTenantMetadata: "",
                deleteTenantMetadataDate: new Date('2019-01-01'),
                deletePassword: "",
                insertMessage: "",
                insertMessageContent: "",
                insertMessageText: "",
                country: this.props.data.country != null ? this.props.data.country : "",

                partner: this.props.data.partner != null ? this.props.data.partner : "",
                onboardingDate: (this.props.data.onboardingDate !== '' && this.props.data.onboardingDate !== '0001-01-01T00:00:00.0000000') ? new Date(this.props.data.onboardingDate) : '',
                billingDate: (this.props.data.billingDate !== '' && this.props.data.billingDate !== '0001-01-01T00:00:00.0000000') ? new Date(this.props.data.billingDate) : '',
                trainingDate: (this.props.data.trainingDate !== '' && this.props.data.trainingDate !== '0001-01-01T00:00:00.0000000') ? new Date(this.props.data.trainingDate) : '',
                supportNotes: this.props.data.supportNotes != null ? this.props.data.supportNotes : "",
                systemId: this.props.data.systemId != null ? this.props.data.systemId : "",
                bots: [],
                support: this.props.data.support != null ? this.props.data.support : "",
                partnerContract: this.props.data.partnerContract != null ? this.props.data.partnerContract : "",
                botVisible: false,
                showExportPanel: false,
                showImportPanel: false,
                showAudioStoragePanel: false,
                showBotOnboardingPanel: false,
                keyManagementEnabled: this.props.data.keyManagementEnabled != null ? this.props.data.keyManagementEnabled : false,
                chatModelA: this.props.data.chatModelA != null ? this.props.data.chatModelA : false,
                showTicketPage: this.props.data.showTicketPage != null ? this.props.data.showTicketPage : false,
                validateKeyVault: "",
                domainRestrictionsList: this.props.data.domainRestrictionsList,
                isChecked: false,
                showModal: false,
                packageImport: this.props.data.packageImport != null ? this.props.data.packageImport : 0,
                packageArchive: this.props.data.packageArchive != null ? this.props.data.packageArchive : 0,
                tenantSuspensionConvDelProcess: this.props.data.tenantSuspensionConvDelProcess !== null ? this.props.data.tenantSuspensionConvDelProcess : false,
                deletionNotifyMessage: false,
                keyExpirationMessage: false,
                keyExpirationButtonMessage: false,
                maxTtlFound: "0",
                keyExpirationConfirmed: true,
                awsAccessKeyId: this.props.data !== null ? this.props.data.awsAccessKeyId : "",
                awsSecretAccess: this.props.data !== null ? this.props.data.awsSecretAccess : "",
                awsBucketName: this.props.data !== null ? this.props.data.awsBucketName : "",
                awsRegion: this.props.data !== null ? this.props.data.awsRegion : "",
                s3Check: "",
                awsType: this.props.data !== null ? this.props.data.awsType : "",
                awsServiceUrl: this.props.data !== null ? this.props.data.awsServiceUrl : "",
                asymmetricKeyEnabled: this.props.data.keyManagement != null ? this.props.data.keyManagement.asymmetricKeyEnabled : false,
                keyType: this.props.data.keyManagement.asymmetricKeySettings != null ? this.props.data.keyManagement.asymmetricKeySettings.keyType : "RSA",
                keySetting: this.props.data.keyManagement.asymmetricKeySettings != null ? this.props.data.keyManagement.asymmetricKeySettings.keySetting : "",
                asymmetricKeyFileName: this.props.data.keyManagement.asymmetricKeySettings != null ? this.props.data.keyManagement.asymmetricKeySettings.asymmetricKeyFileName : "",
                uploadedContent: "",
                selectedFile: this.props.data.keyManagement.asymmetricKeySettings != null && this.props.data.keyManagement.asymmetricKeySettings != "" ? true : false,
                asymmetricKeySuccess: false,
                isActivateAsymmetricKeyDisabled: false,
                asymmetricKeyButtonText: "createAsymmetricKey"
            }
        }
        else {
            this.state = {
                name: "",
                adminId: "",
                tenantId: "",
                id: null,
                license1: 0,
                license1used: 0,
                license1id: Utils.guidGenerator(),
                license2: 0,
                license2used: 0,
                license2id: Utils.guidGenerator(),
                license3used: 0,
                license3: 0,
                license3id: Utils.guidGenerator(),
                license4: 0,
                license4used: 0,
                license4id: Utils.guidGenerator(),
                license5: 0,
                license5used: 0,
                license5id: Utils.guidGenerator(),
                license6: 0,
                license6used: 0,
                license6id: Utils.guidGenerator(),
                license7: 0,
                license7used: 0,
                license7id: Utils.guidGenerator(),
                license8: 0,
                license8used: 0,
                license8id: Utils.guidGenerator(),
                license9: 0,
                license9used: 0,
                license9id: Utils.guidGenerator(),
                license10: 0,
                license10used: 0,
                license10id: Utils.guidGenerator(),
                license11: 0,
                license11used: 0,
                license11id: Utils.guidGenerator(),
                license12: 0,
                license12used: 0,
                license12id: Utils.guidGenerator(),
                storage: "",
                oldStorage: "Unknown",
                customStorage: "",
                packageStorage: 0,
                packageAnalyticsSpeech: 0,
                packageAnalyticsTranscript: 0,
                packageAnalyticsBatchTranscript: 0,
                packageAnalyticsVideo: 0,
                packageAnalyticsTranslate: 0,
                packageAnalyticsAI: 0,
                packageExport: 0,
                addOnFullChat: 0,
                addOnZoom: 0,
                addOnCicso: 0,
                addOnRingcentral: 0,
                addOnDynamics: 0,
                addOnCompliance: 0,
                addOnQualityManagement: 0,
                addOnAnalytics: 0,
                addOnAIEntry: 0,
                addOnLeapXpert: 0,
                addOnEmail: 0,
                addOnN1Mapping:0,
                addOnMsftTeamsVoice: 0,
                addOnMsftTeamsUC: 0,
                contractNumber: "",
                mailAlarming: "",
                exportType: "No",
                exportStorage: "",
                type: "",
                keyManagementType: "No",
                keySecurity: "Aes128",
                rotationType: "Interval",
                intervalDays: 365,
                activationDelay: 0,
                willExpire: false,
                expireDays: 0,
                customEncryptionKeyVaultUrl: "",
                customEncryptionKeySecretName: "",
                manualCreationCustom: false,
                manualCreationKeyRotation: false,
                isChanged: false,
                bulkImport: false,
                bulkLicense: "0",
                bulkRuleRecording: "",
                bulkRuleReplay: "",
                bulkRuleAccess: "",
                bulkRuleAnalytics: "",
                bulkUserList: "",
                bulkImportText: "",
                deleteTenantText: "",
                deleteTenant: "",
                deleteTenantMetadataText: "",
                deleteTenantMetadata: "",
                deleteTenantMetadataDate: new Date('0001-01-01'),
                deletePassword: "",
                insertMessage: "",
                insertMessageContent: "",
                insertMessageText: "",
                country: "",
                partner: "",
                onboardingDate: new Date('1901-01-01'),
                billingDate: new Date('1901-01-01'),
                trainingDate: new Date('1901-01-01'),
                supportNotes: "",
                systemId: "",
                bots: [],
                support: "",
                partnerContract: "",
                showExportPanel: false,
                showImportPanel: false,
                showAudioStoragePanel: false,
                botVisible: false,
                keyManagementEnabled: true,
                chatModelA: false,
                showTicketPage: false,
                validateKeyVault: "",
                domainRestrictionsList: "",
                isChecked: false,
                showModal: false,
                packageImport: 0,
                tenantSuspensionConvDelProcess: false,
                deletionNotifyMessage: false,
                packageArchive: 0,
                maxTtlFound: 0,
                keyExpirationConfirmed: true,
                awsAccessKeyId: "",
                awsSecretAccess: "",
                awsBucketName: "",
                awsRegion: "",
                s3Check: "",
                awsServiceUrl: "",
                awsType: "",
                asymmetricKeyEnabled: false,
                keyType: "",
                keySetting: "",
                asymmetricKeyFileName: "",
                uploadedContent: "",
                selectedFile: false,
                asymmetricKeySuccess: false,
                asymmetricKeyButtonText: "createAsymmetricKey",

            }
        }
    }



    styles = {
        root: {
            paddingTop: "20px"
        }
    };


    saveDisableCheck = () => {
        let checkForS3 = true;
        let checkForAsymmetricKey = true;

        //S3 validation
        let check = this.state.s3Check;
        if (check == "false" || check == "pending") {
            checkForS3 = false;
        }
        if ((check == "" || check == "true") && this.state.storage == "S3Storage") {
            checkForS3 = true;
        }

        //asymmetric key uploaded and created validation
        if (this.state.asymmetricKeyEnabled) {
            if (!this.state.asymmetricKeySuccess) {
                checkForAsymmetricKey = false;
            }
        }

        if (this.state.isChanged && this.state.keyExpirationConfirmed && checkForS3 && checkForAsymmetricKey) {
            return false; //save button is enabled
        }
        return true; //save button is disabled

    }


    render() {
        let auth = this.props.authorization;
        return (<Stack vertical>
            <TextField label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "name")}</>)}</MyContext.Consumer>}
                onChange={(event) => { this.handleChange(event.target.value, 0) }}
                value={this.state.name}
                disabled
            />
            <Stack.Item >
                <Stack>
                    <Stack.Item styles={this.styles}>
                        {this.props.data == null && <TextField label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "tenantId")}</>)}</MyContext.Consumer>}
                            onChange={(event) => { this.handleChange(event.target.value, 1) }}
                            value={this.state.tenantId}
                            onKeyDown={this._handleKeyDown}
                            disabled
                        />}
                        {this.props.data != null && this.props.data.tenantId !== "" && <TextField label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "tenantId")}</>)}</MyContext.Consumer>}
                            value={this.state.tenantId}
                            onKeyDown={this._handleKeyDown}
                            disabled
                        />}
                    </Stack.Item>
                    <Stack.Item styles={this.styles}>
                        <TextField label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "adminId")}</>)}</MyContext.Consumer>}
                            onChange={(event) => { this.handleChange(event.target.value, 2) }}
                            value={this.state.adminId}
                            onKeyDown={this._handleKeyDown}
                            disabled
                        />
                        <hr />
                    </Stack.Item>
                  

                    {this.props.userRules.ruleAccess.tenantCreate && <Stack.Item>
                        <TextField min={0} value={this.state.license10} type="Number" label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "licenseRecordingInsinghtsAI")}</>)}</MyContext.Consumer>}
                            onChange={(event) => { this.handleChange(event.target.value, 84) }}
                        />
                        <hr />
                    </Stack.Item>}
                  


                    {this.props.userRules.ruleAccess.tenantCreate && <Stack.Item>

                        <TextField min={0} value={this.state.addOnQualityManagement} type="Number" label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "addOnQualityManagement")}</>)}</MyContext.Consumer>}
                            onChange={(event) => { this.handleChange(event.target.value, 85) }}
                        />
                        <hr />

                    </Stack.Item>}

                    {this.props.userRules.ruleAccess.tenantCreate && <Stack.Item>
                        <TextField min={0} value={this.state.addOnAIEntry} type="Number" label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "addOnAIEntry")}</>)}</MyContext.Consumer>}
                            onChange={(event) => { this.handleChange(event.target.value, 103) }}
                        />
                        <hr />

                    </Stack.Item>}


                    {this.props.userRules.ruleAccess.tenantCreate && <Stack.Item styles={this.styles}>
                        <TextField min={0} value={this.state.packageAnalyticsTranscript} type="Number" label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "packageAnaTranscript")}</>)}</MyContext.Consumer>}
                            onChange={(event) => { this.handleChange(event.target.value, 59) }}
                        />
                    </Stack.Item>}
                    {this.props.userRules.ruleAccess.tenantCreate && <Stack.Item styles={this.styles}>
                        <TextField min={0} value={this.state.packageAnalyticsBatchTranscript} type="Number" label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "packageBatchTranscript")}</>)}</MyContext.Consumer>}
                            onChange={(event) => { this.handleChange(event.target.value, 96) }}
                        />
                    </Stack.Item>}
                    {this.props.userRules.ruleAccess.tenantCreate && <Stack.Item styles={this.styles}>
                        <TextField min={0} value={this.state.packageAnalyticsTranslate} type="Number" label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "packageAnaTranslate")}</>)}</MyContext.Consumer>}
                            onChange={(event) => { this.handleChange(event.target.value, 19) }}
                        />
                    </Stack.Item>}
                    {this.props.userRules.ruleAccess.tenantCreate && <Stack.Item styles={this.styles}>
                        <TextField min={0} value={this.state.packageAnalyticsAI} type="Number" label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "packageAnaAI")}</>)}</MyContext.Consumer>}
                            onChange={(event) => { this.handleChange(event.target.value, 76) }}
                        />
                        <br />

                    </Stack.Item>}
                    {this.props.userRules.ruleAccess.tenantCreate && <>
                        <br />
                        <hr />
                    </>}

                    {this.props.userRules.ruleAccess.tenantCreate && <Stack.Item>
                        <TextField min={0} value={this.state.packageStorage} type="Number" label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "packageStorage")}</>)}</MyContext.Consumer>}
                            onChange={(event) => { this.handleChange(event.target.value, 14) }}
                        />
                        <br />

                    </Stack.Item>}



                    {this.props.userRules.ruleAccess.tenantCreate && <>
                        <br />
                        <hr />
                    </>}






                    {this.props.userRules.ruleAccess.tenantCreate && <Stack.Item styles={this.styles}>
                        <TextField value={this.state.partner} label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "partner")}</>)}</MyContext.Consumer>}
                            onChange={(event) => { this.handleChange(event.target.value, 25) }}
                            disabled
                        />
                    </Stack.Item>}
                    {this.props.userRules.ruleAccess.tenantCreate && this.state.partner && <Stack.Item styles={this.styles}>
                        <Checkbox
                            id={"showTicketPage"}
                            label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "showTicketPage")}</>)}</MyContext.Consumer>}
                            checked={this.state.showTicketPage}
                            onChange={(event, newValue) => {
                                this.handleChange(newValue, 105);
                            }}
                        />
                    </Stack.Item>}
                    {this.props.userRules.ruleAccess.tenantCreate && <Stack.Item styles={this.styles}>
                        <TextField value={this.state.partnerContract} label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "partnerContract")}</>)}</MyContext.Consumer>}
                            onChange={(event) => { this.handleChange(event.target.value, 26) }}
                        />
                    </Stack.Item>}
                    {this.props.userRules.ruleAccess.tenantCreate && <Stack.Item styles={this.styles}>
                        <TextField value={this.state.support} label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "support")}</>)}</MyContext.Consumer>}
                            onChange={(event) => { this.handleChange(event.target.value, 27) }}
                        />
                    </Stack.Item>}





                    {!this.props.userRules.ruleAccess.tenantCreate && <Stack>


                        {this.state.license10 > 0 ?
                            <Stack.Item styles={this.styles}>
                                <TextField min={0} value={this.state.license10} type="Number" label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "licenseRecordingInsinghtsAI")}</>)}</MyContext.Consumer>} disabled />
                            </Stack.Item>
                            : <div></div>
                        }
                        {(this.state.license10 > 0) && <>
                            <br />
                            <hr />
                        </>}


                        {this.state.addOnQualityManagement > 0 ?
                            <Stack.Item styles={this.styles}>
                                <TextField min={0} value={this.state.addOnQualityManagement} type="Number" label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "addOnQualityManagement")}</>)}</MyContext.Consumer>} disabled />
                            </Stack.Item>
                            : <div></div>
                        }

                        {(this.state.addOnQualityManagement > 0) && <>
                            <br />
                            <hr />
                        </>}

                        {this.state.addOnAIEntry > 0 ?
                            <Stack.Item>
                                <TextField min={0} value={this.state.addOnAIEntry} type="Number" label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "addOnAIEntry")}</>)}</MyContext.Consumer>} disabled />
                            </Stack.Item>
                            : <div></div>
                        }

                        {(this.state.addOnAIEntry > 0) && <>
                            <br />
                            <hr />
                        </>}

                        {this.state.packageAnalyticsTranscript > 0 ?
                            <Stack.Item>
                                <TextField min={0} value={this.state.packageAnalyticsTranscript} type="Number" label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "packageAnaTranscript")}</>)}</MyContext.Consumer>} disabled />
                            </Stack.Item>
                            : <div></div>
                        }
                        {this.state.packageAnalyticsBatchTranscript > 0 ?
                            <Stack.Item>
                                <TextField min={0} value={this.state.packageAnalyticsBatchTranscript} type="Number" label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "packageBatchTranscript")}</>)}</MyContext.Consumer>} disabled />
                            </Stack.Item>
                            : <div></div>
                        }
                        {this.state.packageAnalyticsTranslate > 0 ?
                            <Stack.Item styles={this.styles}>
                                <TextField min={0} value={this.state.packageAnalyticsTranslate} type="Number" label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "packageAnaTranslate")}</>)}</MyContext.Consumer>} disabled />
                            </Stack.Item>
                            : <div></div>
                        }
                        {this.state.packageAnalyticsAI > 0 ?
                            <Stack.Item styles={this.styles}>
                                <TextField min={0} value={this.state.packageAnalyticsAI} type="Number" label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "packageAnaAI")}</>)}</MyContext.Consumer>} disabled />
                            </Stack.Item>
                            : <div></div>
                        }
                        {(this.state.packageAnalyticsTranscript > 0 || this.state.packageAnalyticsTranslate > 0 || this.state.packageAnalyticsBatchTranscript > 0 || this.state.packageAnalyticsAI > 0) && <>
                            <br />
                            <hr />
                        </>}

                        {this.state.packageStorage > 0 ?
                            <Stack.Item>
                                <TextField min={0} value={this.state.packageStorage} type="Number" label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "packageStorage")}</>)}</MyContext.Consumer>} disabled />
                            </Stack.Item>
                            : <div></div>
                        }


                        {(this.state.packageStorage > 0) && <>
                            <br />
                            <hr />
                        </>}




                        {(this.props.userRules.ruleAccess.tenantCreate || this.props.userRules.access == "OrderMitel")
                            && <Stack>

                                <Stack.Item styles={this.styles}>
                                    <TextField value={this.state.partner} label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "partner")}</>)}</MyContext.Consumer>}
                                        onChange={(event) => { this.handleChange(event.target.value, 25) }}
                                        disabled
                                    />
                                </Stack.Item>
                                {this.state.partner && <Stack.Item styles={this.styles}>
                                    <Checkbox
                                        id={"showTicketPage2"}
                                        label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "showTicketPage")}</>)}</MyContext.Consumer>}
                                        checked={this.state.showTicketPage}
                                        onChange={(event, newValue) => {
                                            this.handleChange(newValue, 105);
                                        }}
                                    />
                                </Stack.Item>}
                                <Stack.Item styles={this.styles}>
                                    <TextField value={this.state.partnerContract} label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "partnerContract")}</>)}</MyContext.Consumer>}
                                        onChange={(event) => { this.handleChange(event.target.value, 26) }}
                                    />
                                </Stack.Item>
                                <Stack.Item styles={this.styles}>
                                    <TextField value={this.state.support} label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "support")}</>)}</MyContext.Consumer>}
                                        onChange={(event) => { this.handleChange(event.target.value, 27) }}
                                    />
                                </Stack.Item>
                            </Stack>}
                    </Stack>}


                    {(this.props.userRules.ruleAccess.tenantCreate
                        || this.props.userRules.access == "OrderMitel")
                        && <Stack.Item styles={this.styles}>
                            <Stack.Item>
                                <div>Onboarding Date</div>
                                <DatePicker
                                    onSelectDate={(date) => {
                                        this.handleChange(date, 23)
                                    }}
                                    value={this.state.onboardingDate}
                                    disabled
                                />
                                <div>Training Date</div>
                                <DatePicker
                                    onSelectDate={(date) => {
                                        this.handleChange(date, 65)
                                    }}
                                    value={this.state.trainingDate}
                                    disabled
                                />
                                <div>Billing Date</div>
                                <DatePicker
                                    onSelectDate={(date) => {
                                        this.handleChange(date, 24)
                                    }}
                                    value={this.state.billingDate}
                                    disabled
                                />
                            </Stack.Item>
                            <Stack.Item styles={this.styles}>
                                <TextField value={this.state.supportNotes} label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "supportNotes")}</>)}</MyContext.Consumer>}
                                    onChange={(event) => { this.handleChange(event.target.value, 66) }}
                                />
                            </Stack.Item>

                        </Stack.Item>}

                    {(this.props.userRules.ruleAccess.tenantCreate
                        || this.props.userRules.access == "OrderMitel") &&
                        <Stack.Item>
                            <ComboBox
                                style={{ width: "300px" }}
                                placeholder="Select an option"
                                label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "customerType")}</>)}</MyContext.Consumer>}
                                unknown
                                Europa
                                USA
                                Asia
                                options={[{
                                    key: "Unknown",
                                    text: "Unknown"
                                },
                                {
                                    key: "Paid",
                                    text: "Paid",
                                },
                                {
                                    key: "Trial",
                                    text: "End Customer Trial",
                                },
                                {
                                    key: "Partner",
                                    text: "Partner Trial",
                                }]
                                }
                                selectedKey={this.state.type}
                                onChange={(event, option, index, newValue) => { this.handleChange(option.key, 13) }}
                                disabled
                            />
                        </Stack.Item>}


                    {/*new storage*/}
                    <Stack>
                        <Stack.Item>
                            <Query
                                query={getStorageData}
                                variables={{}}
                            >
                                {({ loading, error, data }) => {
                                    if (loading) {
                                        return (
                                            <div style={{ float: "left", "marginLeft": "50px" }}>
                                                <Spinner label={<MyContext.Consumer>{(context) => (<>{context.getTranslation("common", "loading")}</>)}</MyContext.Consumer>} ariaLive="assertive" labelPosition="top" />
                                            </div>
                                        );
                                    }


                                    if (error) return <h4>Failed to connect</h4>;
                                    if (data.getStorageData == null) {
                                        return <div />;
                                    }

                                    let storagesList = [];
                                    if (data.getStorageData != null) {
                                        for (var i = 0; i < data.getStorageData.length; i++) {

                                            storagesList.push({
                                                key: data.getStorageData[i].id,
                                                text: data.getStorageData[i].displayName
                                            });
                                        }

                                    }

                                    return <Dropdown
                                        label={<MyContext.Consumer>{(context) => (<>{context.getTranslation("tenants", "globalStorage")}</>)}</MyContext.Consumer>}
                                        placeholder={<MyContext.Consumer>{(context) => (<>{context.getTranslation("common", "selectAnOptionRegional")}</>)}</MyContext.Consumer>}
                                        //onChange={(event, option, index, newValue) => { this.handleChange(option.key, 5) }}
                                        defaultSelectedKey={this.state.storage}
                                        options={storagesList}
                                        disabled
                                    />

                                }}

                            </Query>
                        </Stack.Item>
                    </Stack>


                    {/*    old storage*/}
                    {/*display old storage if new storage is null------------------------------------------------------------------------------------------*/}
                    {(this.props.data !== null && this.props.data.storageId === null) &&
                        <Stack>
                            <Stack.Item>
                                <ComboBox
                                    style={{ width: "300px" }}
                                    placeholder="Select an option"
                                    label="Old Storage"

                                    options={[{
                                        key: "Unknown",
                                        text: "Unknown"
                                    },
                                    {
                                        key: "Emea",
                                        text: "EMEA GRS",
                                    },
                                    {
                                        key: "UkSouth",
                                        text: "UK South GRS",
                                    },
                                    {
                                        key: "Apac",
                                        text: "APAC GRS",
                                    },
                                    {
                                        key: "Americas",
                                        text: "Americas GRS",
                                    },
                                    {
                                        key: "Brazil",
                                        text: "Brazil GRS",
                                    },
                                    {
                                        key: "Canada",
                                        text: "Canada GRS",
                                    },
                                    {
                                        key: "Japan",
                                        text: "Japan GRS",
                                    },
                                    {
                                        key: "Switzerland",
                                        text: "Switzerland GRS",
                                    },
                                    {
                                        key: 'UAENorth',
                                        text: "UAE North GRS"
                                    },

                                    {
                                        key: "LrsEmea",
                                        text: "EMEA LRS",
                                    },
                                    {
                                        key: "LrsUkSouth",
                                        text: "UK South LRS",
                                    },
                                    {
                                        key: "LrsApac",
                                        text: "APAC LRS",
                                    },
                                    {
                                        key: "LrsAmericas",
                                        text: "Americas LRS",
                                    },
                                    {
                                        key: "LrsBrazil",
                                        text: "Brazil LRS",
                                    },
                                    {
                                        key: "LrsCanada",
                                        text: "Canada LRS",
                                    },
                                    {
                                        key: "LrsJapan",
                                        text: "Japan LRS",
                                    },
                                    {
                                        key: "LrsSwitzerland",
                                        text: "Switzerland LRS",
                                    },
                                    {
                                        key: 'LrsUAENorth',
                                        text: "UAE North LRS"
                                    },

                                    {
                                        key: "GrsSwiss",
                                        text: "Swiss GRS",
                                        disabled: true
                                    },

                                    {
                                        key: "LrsAustralia",
                                        text: "Australia LRS"
                                    },

                                    {
                                        key: "Australia",
                                        text: "Australia GRS"
                                    },

                                    {
                                        key: "LrsApacSe",
                                        text: "APAC Southeast LRS"
                                    },

                                    {
                                        key: "ApacSe",
                                        text: "APAC Southeast GRS"
                                    },


                                    {
                                        key: "CustomStorage",
                                        text: "Own Storage",
                                    }]
                                    }
                                    selectedKey={this.state.oldStorage}
                                    disabled
                                />
                            </Stack.Item>
                        </Stack>}

                    <Stack>



                        {this.state.oldStorage == "CustomStorage" &&
                            <Stack.Item>
                                <TextField label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("configuration", "storageConnectionString")}</>)}</MyContext.Consumer>}
                                    onChange={(event) => { this.handleChange(event.target.value, 21) }}
                                    value={this.state.customStorage}
                                    onKeyDown={this._handleKeyDown}
                                    disabled
                                />
                            </Stack.Item>}

                        {this.state.oldStorage === 'S3Storage' && <>
                            <ComboBox
                                style={{ width: "300px" }}
                                placeholder="Select an option"
                                label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("configuration", "awsType")}</>)}</MyContext.Consumer>}
                                options={[
                                    { key: "Cloud", text: "Cloud" },
                                    { key: "OnPremise", text: "On-premise" },

                                ]}
                                selectedKey={this.state.awsType}
                                onChange={(ev, newVal) => {
                                    this.setState({
                                        awsType: newVal.key,
                                        s3Check: "false",
                                        changed: true
                                    });
                                }}
                                disabled
                                errorMessage={this.state.awsType == "" || this.state.awsType == null ? "Aws type must be selected" : ""}
                            />
                            <TextField
                                type={"text"}
                                label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("configuration", "awsAccessKeyId")}</>)}</MyContext.Consumer>}
                                value={this.state.awsAccessKeyId}
                                errorMessage={(this.state.awsAccessKeyId === "" || this.state.awsAccessKeyId === null) ? "Access Key Id cannot be empty" : ""}
                                onChange={(event) => { this.handleChange(event.target.value, 77) }}
                                disabled
                            />
                            <TextField
                                type={"text"}
                                label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("configuration", "awsSecretAccess")}</>)}</MyContext.Consumer>}
                                value={this.state.awsSecretAccess}
                                errorMessage={(this.state.awsSecretAccess === "" || this.state.awsSecretAccess === null) ? "Secret Access key cannot be empty" : ""}
                                onChange={(event) => { this.handleChange(event.target.value, 78) }}
                                disabled
                            />
                            {this.state.awsType == "OnPremise" &&
                                <TextField
                                    type={"text"}
                                    label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("configuration", "awsServiceUrl")}</>)}</MyContext.Consumer>}
                                    value={this.state.awsServiceUrl}
                                    errorMessage={(this.state.awsServiceUrl === "" || this.state.awsServiceUrl === null) ? "Service Url cannot be empty" : ""}
                                    onChange={(event, newValue) => {
                                        this.setState({
                                            awsServiceUrl: newValue,
                                            s3Check: "false",
                                            changed: true
                                        });
                                    }}
                                    disabled
                                />}
                            <TextField
                                type={"text"}
                                label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("configuration", "awsBucketName")}</>)}</MyContext.Consumer>}
                                value={this.state.awsBucketName}
                                errorMessage={(this.state.awsBucketName === "" || this.state.awsBucketName === null) ? "Bucket name cannot be empty" : ""}
                                onChange={(event) => { this.handleChange(event.target.value, 79) }}
                                disabled
                            />
                            {this.state.awsType === "Cloud" &&
                                <Query
                                    query={queryGetAWSRegions}
                                    variables={this.props.authorization} >
                                    {({ loading, error, data }) => {
                                        if (loading) return <div>
                                            <Spinner label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("common", "loadingRegions")}</>)}</MyContext.Consumer>} ariaLive="assertive" labelPosition="top" />
                                        </div>;
                                        if (error) return <h1> </h1>;

                                        if (data.getAWSRegions == null) {
                                            return <div></div>;
                                        }
                                        this.tmpKey = [];
                                        const stack = data.getAWSRegions;
                                        if (data.getAWSRegions != null) {
                                            for (let x = 0; x < stack.length; x++) {
                                                let i = {
                                                    key: stack[x].code,
                                                    text: stack[x].displayName,
                                                };
                                                this.tmpKey.push(i);
                                            }
                                        }

                                        return <ComboBox
                                            style={{ width: "300px" }}
                                            placeholder="Select an option"
                                            label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("configuration", "defaultRegion")}</>)}</MyContext.Consumer>}
                                            options={this.tmpKey}
                                            selectedKey={this.state.awsRegion}
                                            onChange={(ev, newVal) => {
                                                this.setState({
                                                    awsRegion: newVal.key,
                                                    s3Check: "false",
                                                    isChanged: true
                                                });
                                            }}
                                            disabled
                                            errorMessage={this.state.awsRegion == "" || this.state.awsRegion == null ? "Default region must be selected" : ""}
                                        />
                                    }}
                                </Query>}
                            <br />

                        </>}
                    </Stack>


                    <Stack.Item styles={this.styles}>
                        <TextField value={this.state.mailAlarming} label={"Mail Alarming"}
                            onChange={(event) => { this.handleChange(event.target.value, 17) }}
                        />
                    </Stack.Item>

                </Stack>
            </Stack.Item>

            <Stack.Item styles={this.styles}>
                <Stack horizontal>
                    <Stack.Item>
                        <DefaultButton onClick={(event) => { this.props.cl() }} text={<MyContext.Consumer>{(context) => (<> {context.getTranslation("common", "cancel")}</>)}</MyContext.Consumer>} />
                    </Stack.Item>
                    <Stack.Item>
                        <PrimaryButton
                            id="saveBtn"
                            onClick={(event) => { this.notifyTenantChange(this.props.apol); this.props.cl() }}
                            text={<MyContext.Consumer>{(context) => (<> {context.getTranslation("common", "save")}</>)}</MyContext.Consumer>}
                            disabled={this.saveDisableCheck()} />
                    </Stack.Item>
                </Stack>
            </Stack.Item>

        </Stack>
        );
    }

    query = (auth) => {
        return (<Query
            query={queryGetRuleData}
            variables={{ auth }}>
            {({ loading, error, data }) => {
                if (loading) return <div>
                    <Spinner label="Loading Rules ..." ariaLive="assertive" labelPosition="top" />
                </div>;
                if (error) return <h1> </h1>;

                if (data.getRuleData == null) {
                    return <div> </div>;
                }
                return <Stack><Stack.Item styles={this.styles}>
                    <ComboBox
                        style={{ width: "300px" }}
                        placeholder="Select an option"
                        label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "exportCycle")}</>)}</MyContext.Consumer>}
                        options={[{
                            key: "1",
                            text: "Compliance UC License"
                        },
                        {
                            key: "2",
                            text: "Compliance&Analytics UC License",
                        },
                        {
                            key: "3",
                            text: "Smart UC License",
                        },
                        {
                            key: "4",
                            text: "Smart&Analytics UC License",
                        },
                        {
                            key: "5",
                            text: "Chat Recording Standalone License"
                        },
                        {
                            key: "6",
                            text: "Compliance Voice License"
                        },
                        {
                            key: "7",
                            text: "Compliance Voice & Analytics License"
                        },
                        {
                            key: "8",
                            text: "Smart Voice License"
                        },
                        {
                            key: "9",
                            text: "Smart Voice & Analytics License"
                        }]
                        }
                        selectedKey={this.state.bulkLicense}
                        onChange={(event, option, index, newValue) => { this.setState({ bulkLicense: option.key }) }}
                    />
                </Stack.Item>
                    <Stack.Item styles={this.styles}>
                        <Dropdown placeholder="Select an option" label="Recording" selectedKey={this.state.bulkRuleRecording} onChange={(event, newValue) => { this.setState({ bulkRuleRecording: newValue.key }) }} options={recordingOption(data.getRuleData.ruledata)} styles={dropdownStyles} />
                        <Dropdown placeholder="Select an option" label="Replay" selectedKey={this.state.bulkRuleReplay} onChange={(event, newValue) => { this.setState({ bulkRuleReplay: newValue.key }) }} options={replayOption(data.getRuleData.ruledata)} styles={dropdownStyles} />
                        <Dropdown placeholder="Select an option" label="Access" selectedKey={this.state.bulkRuleAccess} onChange={(event, newValue) => { this.setState({ bulkRuleAccess: newValue.key }) }} options={accessOption(data.getRuleData.ruledata)} styles={dropdownStyles} />
                        <Dropdown placeholder="Select an option" label="Analytics" selectedKey={this.state.bulkRuleAnalytics} onChange={(event, newValue) => { this.setState({ bulkRuleAnalytics: newValue.key }) }} options={analyticsOption(data.getRuleData.ruledata)} styles={dropdownStyles} />
                    </Stack.Item>
                    <Stack.Item>
                        <TextField label={"User List"}
                            onChange={(event) => { this.setState({ bulkUserList: event.target.value }) }}
                            value={this.state.bulkUserList}
                        />
                    </Stack.Item>
                    <Stack.Item styles={this.styles}>
                        <PrimaryButton
                            onClick={(event) => { this.bulkImport(this.props.apol); }}
                            text={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "import")}</>)}</MyContext.Consumer>} disabled={this.state.bulkUserList == "" || this.state.bulkLicense == ""} />
                    </Stack.Item>
                    <Stack.Item styles={this.styles}>
                        <Text>{this.state.bulkImportText}</Text>
                    </Stack.Item>
                </Stack>

            }}
        </Query>);
    };

    handleChange(text, id) {
        switch (id) {
            case 0: this.setState({ name: text }); break;
            case 1: this.setState({ tenantId: text }); break;
            case 2: this.setState({ adminId: text }); break;
            case 3: this.setState({ license1: text }); break;
            case 4: this.setState({ license2: text }); break;
            case 5: if (text === "S3Storage") {
                this.setState({
                    s3Check: "false",
                    storage: text,
                    asymmetricKeyEnabled: false
                });
            } else {
                this.setState({
                    s3Check: "",
                    storage: text,
                })
            } break;
            case 6: this.setState({ exportType: text }); break;
            case 7: this.setState({ exportStorage: text }); break;
            case 10: this.setState({ license3: text }); break;
            case 11: this.setState({ license4: text }); break;
            case 12: this.setState({ license5: text }); break;
            case 13: this.setState({ type: text }); break;
            case 14: this.setState({ packageStorage: text }); break;
            case 15: this.setState({ packageAnalyticsVideo: text }); break;
            case 16: this.setState({ packageExport: parseInt(text) }); break;
            case 17: this.setState({ mailAlarming: text }); break;
            case 18: this.setState({ packageAnalyticsSpeech: text }); break;
            case 19: this.setState({ packageAnalyticsTranslate: text }); break;
            case 20: this.setState({ contractNumber: text }); break;
            case 21: this.setState({ customStorage: text }); break;
            case 22: this.setState({ country: text }); break;
            case 23: this.setState({ onboardingDate: text }); break;
            case 24: this.setState({ billingDate: text }); break;
            case 25: this.setState({ partner: text }); break;
            case 26: this.setState({ partnerContract: text }); break;
            case 27: this.setState({ support: text }); break;
            case 48: this.setState({ keyManagementType: text }); break;
            case 49: this.setState({ keySecurity: text }); break;
            case 50: this.setState({ customEncryptionKeyVaultUrl: text }); break;
            case 51: this.setState({ customEncryptionKeySecretName: text }); break;
            case 52: this.setState({ intervalDays: text == 0 ? 1 : parseInt(text) }); break;
            case 53: this.setState({ activationDelay: text }); break;
            case 54: this.setState({ expireDays: parseInt(text), keyExpirationConfirmed: false }); break;
            case 55: this.setState({ rotationType: text }); break;
            case 56: this.setState({ willExpire: text, keyExpirationMessage: text }); break;
            case 57: this.setState({ license6: text }); break;
            case 58: this.setState({ license7: text }); break;
            case 59: this.setState({ packageAnalyticsTranscript: text }); break;
            case 60: this.setState({ license8: text }); break;
            case 61: this.setState({ license9: text }); break;
            case 62: this.setState({ addOnAnalytics: text }); break;
            case 63: this.setState({ addOnFullChat: text }); break;

            case 64: this.setState({ domainRestrictionsList: text }); break;
            case 65: this.setState({ trainingDate: text }); break;
            case 66: this.setState({ supportNotes: text }); break;
            case 67: this.setState({ systemId: text }); break;
            case 68: this.setState({ addOnZoom: text }); break;
            case 69: this.setState({ addOnGenesys: text }); break;
            case 70: this.setState({ addOnRingcentral: text }); break;
            case 71: this.setState({ addOnDynamics: text }); break;
            case 72: this.setState({ addOnCompliance: text }); break;
            case 73: this.setState({ packageImport: parseInt(text) }); break;
            case 74: this.setState({ packageArchive: parseInt(text) }); break;
            case 75: this.setState({ tenantSuspensionConvDelProcess: text, deletionNotifyMessage: true }); break;
            case 76: this.setState({ packageAnalyticsAI: text }); break;
            case 77: this.setState({ awsAccessKeyId: text, s3Check: "false" }); break;
            case 78: this.setState({ awsSecretAccess: text, s3Check: "false" }); break;
            case 79: this.setState({ awsBucketName: text, s3Check: "false" }); break;
            case 80: this.setState({ asymmetricKeyEnabled: text, rotationType: "Manual" }); break;
            case 81: this.setState({ keyType: text }); break;
            case 82: this.setState({ keySetting: text }); break;
            case 83: this.setState({ addOnLeapXpert: text }); break;
            case 84: this.setState({ license10: text }); break;


            case 85: this.setState({ addOnQualityManagement: text }); break;
            case 86: this.setState({ chatModelA: text }); break;
            case 96: this.setState({ packageAnalyticsBatchTranscript: text }); break;
            case 97: this.setState({ license11: text }); break;
            case 99: this.setState({ license12: text }); break;
            case 100: this.setState({ addOnMsftTeamsVoice: text }); break;
            case 101: this.setState({ addOnMsftTeamsUC: text }); break;
            case 102: this.setState({ addOnEmail: text }); break;
            case 103: this.setState({ addOnAIEntry: text }); break;
            case 105: this.setState({ showTicketPage: text }); break;
            case 87: break;
            default: break;

        }
        // Decide to set isChanged
        if (/^[0-9A-Fa-f]{8}(?:-[0-9A-Fa-f]{4}){3}-[0-9A-Fa-f]{12}$/.test(id === 1 ? text : this.state.tenantId)
            && /^[0-9A-Fa-f]{8}(?:-[0-9A-Fa-f]{4}){3}-[0-9A-Fa-f]{12}$/.test(id === 2 ? text : this.state.adminId)
            && (this.state.storage !== "Own" || this.state.customStorage != "")
            && (id === 0 ? text : this.state.name) !== ""
            && (id === 5 ? text : this.state.storage) !== "Unknown"
            && ((id === 3 ? text : this.state.license1) !== 0
                || (id === 4 ? text : this.state.license2) !== 0
                || (id === 10 ? text : this.state.license3) !== 0
                || (id === 11 ? text : this.state.license4) !== 0
                || (id === 12 ? text : this.state.license5) !== 0
                || (id === 57 ? text : this.state.license6) !== 0
                || (id === 58 ? text : this.state.license7) !== 0
                || (id === 60 ? text : this.state.license8) !== 0
                || (id === 61 ? text : this.state.license9) !== 0
                || (id === 84 ? text : this.state.license10) !== 0
            )
            && (id === 13 ? text : this.state.type !== "Unknown")
        ) {

            var changed = "";
            if ((id === 48 && text == "CustomKey") || this.state.keyManagementType == "CustomKey") {


                if (this.props.data != null && this.props.data.keyManagementType != null && this.props.data.keyManagementType == "CustomKey" && this.props.data.keyManagement.customEncryptionKeySecretName == this.state.customEncryptionKeySecretName &&
                    this.props.data.keyManagement.customEncryptionKeyVaultUrl == this.state.customEncryptionKeyVaultUrl && this.state.validateKeyVault != "false") {
                    this.setState({ validateKeyVault: "true" });
                    changed = "true";
                }
                if (id === 50 || id === 51 || this.state.validateKeyVault == "false") {
                    this.setState({ validateKeyVault: "false" });
                    changed = "false"
                }
                if (this.state.customEncryptionKeyVaultUrl == "" || this.state.customEncryptionKeySecretName == "") {
                    this.setState({ validateKeyVault: "false" });
                    changed = "false"
                }


                if (changed != "true" && changed != "") {
                    this.setState({ isChanged: false });

                } else {
                    this.setState({ isChanged: true });
                }



            } else {
                this.setState({ isChanged: true });

            }


        } else {
            this.setState({ isChanged: false });
        }

    }

    bulkImport = async (apol) => {
        this.setState({ bulkImportText: "Import running ..." });
        var listUser = this.state.bulkUserList.split(";");
        var sendUserList = [];
        listUser.forEach((aUser) => {
            sendUserList.push({
                userId: aUser,
                license: this.state.bulkLicense,
                access: this.state.bulkRuleAccess,
                recordingRules: this.state.bulkRuleRecording,
                replay: this.state.bulkRuleReplay,
                analytics: this.state.bulkRuleAnalytics,
            });
        });
        var data = await apol
            .mutate({
                mutation: mutationBulkImport,
                variables: {
                    auth: this.props.authorization,
                    user: sendUserList,
                    tenantId: this.props.data.tenantId
                }
            });
        this.setState({ bulkImport: false, bulkImportText: "" });
    }

    groupSync = async (apol) => {
        var data = await apol
            .mutate({
                mutation: userGroupSync,
                variables: {
                    auth: this.props.authorization,
                    tenantId: this.props.data.tenantId
                }
            });

    }

    changeEncryptionKey = async (apol) => {
        var data = await apol
            .mutate({
                mutation: changeEncryptionKey
            });
        if (data) {
            document.getElementById("requestRotation").innerHTML = "Key Rotation Successful";
            document.getElementById("requestRotation").disabled = true;
            this.setState({ isChecked: false })

        } else {
            document.getElementById("requestRotation").innerHTML = "Key Rotation Unsuccessful";
            document.getElementById("requestRotation").disabled = true;
            this.setState({ isChecked: false })

        }
    }

    createCustomKeySecret = async (apol) => {
        var data = await apol
            .mutate({
                mutation: createCustomKeySecret,
                variables: {
                    customKeyVaultUrl: this.state.customEncryptionKeyVaultUrl,
                    customSecretName: this.state.customEncryptionKeySecretName
                }
            });

        if (data.data.createCustomKeySecret == true) {
            this.setState({ validateKeyVault: "true" });
            document.getElementById("secretName").style.border = "2px solid green";
            toast.success("Secret was created successfully", { autoClose: 5000, position: "bottom-left" });
            document.querySelector('#checkBtn').style.border = "2px solid green";
            document.getElementById("secretError").innerHTML = "";
            this.handleChange("", 73);


        } else {
            toast.error("Failed to create secret", { autoClose: 5000, position: "bottom-left" });
            document.getElementById("secretError").innerHTML = "Invalid secret name or SET right is missing. Secret names can only contain alphanumeric characters and dashes.";
            this.handleChange("", 73);

        }
    }








    notifyTenantChange = async (apol) => {
        // Add or change User

        // Repair legacy settings with 0001 year
        if (this.state.onboardingDate.toDateString() === new Date("0001-01-01T00:00:00.0000000").toDateString())
            this.setState({ onboardingDate: new Date("1901-01-01T00:00:00") });
        if (this.state.trainingDate.toDateString() === new Date("0001-01-01T00:00:00.0000000").toDateString())
            this.setState({ trainingDate: new Date("1901-01-01T00:00:00") });
        if (this.state.billingDate.toDateString() === new Date("0001-01-01T00:00:00.0000000").toDateString())
            this.setState({ billingDate: new Date("1901-01-01T00:00:00") });
        let tmpExpireDays = this.state.expireDays;
        if (!this.state.willExpire) {
            tmpExpireDays = 0;
        }
        var tenant = {
            name: this.state.name,
            tenantId: this.state.tenantId,
            adminId: this.state.adminId,
            licenseComp: {
                type: {
                    id: "1",
                    number: "1",
                    text: "1",
                    name: "ComplianceRec"
                },
                bought: parseInt(this.state.license1),
                used: parseInt(this.state.license1used),
                id: this.state.license1id
            },
            licenseCompAna: {
                type: {
                    id: "2",
                    number: "2",
                    text: "2",
                    name: "ComplianceRec&Ana"
                },
                bought: parseInt(this.state.license2),
                used: parseInt(this.state.license2used),
                id: this.state.license2id
            },
            licenseSmart: {
                type: {
                    id: "3",
                    number: "3",
                    text: "3",
                    name: "SmartRec"
                },
                bought: parseInt(this.state.license3),
                used: parseInt(this.state.license3used),
                id: this.state.license3id
            },
            licenseSmartAna: {
                type: {
                    id: "4",
                    number: "4",
                    text: "4",
                    name: "SmartRecAna"
                },
                bought: parseInt(this.state.license4),
                used: parseInt(this.state.license4used),
                id: this.state.license4id
            },
            licenseAna: {
                type: {
                    id: "5",
                    number: "5",
                    text: "5",
                    name: "Ana"
                },
                bought: parseInt(this.state.license5),
                used: parseInt(this.state.license5used),
                id: this.state.license5id
            },
            licenseCompVoice: {
                type: {
                    id: "6",
                    number: "6",
                    text: "6",
                    name: "CompVoice"
                },
                bought: parseInt(this.state.license6),
                used: parseInt(this.state.license6used),
                id: this.state.license6id
            },
            licenseCompVoiceAna: {
                type: {
                    id: "7",
                    number: "7",
                    text: "7",
                    name: "CompVoiceAna"
                },
                bought: parseInt(this.state.license7),
                used: parseInt(this.state.license7used),
                id: this.state.license7id
            },
            licenseSmartVoice: {
                type: {
                    id: "8",
                    number: "8",
                    text: "8",
                    name: "SmartVoice"
                },
                bought: parseInt(this.state.license8),
                used: parseInt(this.state.license8used),
                id: this.state.license8id
            },
            licenseSmartVoiceAna: {
                type: {
                    id: "9",
                    number: "9",
                    text: "9",
                    name: "SmartVoiceAna"
                },
                bought: parseInt(this.state.license9),
                used: parseInt(this.state.license9used),
                id: this.state.license9id
            },
            licenseRecordingInsinghtsAI: {
                type: {
                    id: "10",
                    number: "10",
                    text: "10",
                    name: "LicenseRecordingInsinghtsAI"
                },
                bought: parseInt(this.state.license10),
                used: parseInt(this.state.license10used),
                id: this.state.license10id
            },
            licenseSmartBase: {
                type: {
                    id: "11",
                    number: "11",
                    text: "11",
                    name: "licenseSmartBase"
                },
                bought: parseInt(this.state.license11),
                used: parseInt(this.state.license11used),
                id: this.state.license11id
            },
            licenseComplianceBase: {
                type: {
                    id: "12",
                    number: "12",
                    text: "12",
                    name: "licenseComplianceBase"
                },
                bought: parseInt(this.state.license12),
                used: parseInt(this.state.license12used),
                id: this.state.license12id
            },
            licenseEntryVoiceRecording: {
                type: {
                    id: "13",
                    number: "13",
                    text: "13",
                    name: "licenseEntryVoiceRecording"
                },
                bought: parseInt(this.state.license13),
                used: parseInt(this.state.license13used),
                id: this.state.license13id
            },
         
            storage: this.state.storage,
            packageStorage: parseInt(this.state.packageStorage),
            packageAnalyticsVideo: parseInt(this.state.packageAnalyticsVideo),
            packageAnalyticsSpeech: parseInt(this.state.packageAnalyticsSpeech),
            packageAnalyticsTranscript: parseInt(this.state.packageAnalyticsTranscript),
            packageAnalyticsBatchTranscript: parseInt(this.state.packageAnalyticsBatchTranscript),
            packageAnalyticsTranslate: parseInt(this.state.packageAnalyticsTranslate),
            packageAnalyticsAI: parseInt(this.state.packageAnalyticsAI),
            packageExport: parseInt(this.state.packageExport),
            packageArchive: parseInt(this.state.packageArchive),
            addOnAnalytics: parseInt(this.state.addOnAnalytics),
            addOnAIEntry: parseInt(this.state.addOnAIEntry),
            addOnFullChat: parseInt(this.state.addOnFullChat),
            addOnZoom: parseInt(this.state.addOnZoom),
            addOnGenesys: parseInt(this.state.addOnGenesys),
            addOnRingcentral: parseInt(this.state.addOnRingcentral),
            addOnDynamics: parseInt(this.state.addOnDynamics),
            addOnCompliance: parseInt(this.state.addOnCompliance),
            addOnQualityManagement: parseInt(this.state.addOnQualityManagement),
            addOnLeapXpert: parseInt(this.state.addOnLeapXpert),
            addOnEmail: parseInt(this.state.addOnEmail),
            addOnMsftTeamsVoice: parseInt(this.state.addOnMsftTeamsVoice),
            addOnMsftTeamsUC: parseInt(this.state.addOnMsftTeamsUC),
            addOnN1Mapping: parseInt(this.state.addOnN1Mapping),
            contractNumber: this.state.contractNumber,
            domainRestrictionsList: this.state.domainRestrictionsList,
            mailAlarming: this.state.mailAlarming,
            customStorage: this.state.customStorage,
            exportType: this.state.exportType,
            exportStorage: this.state.exportStorage,
            type: this.state.type,
            id: this.state.id,
            country: this.state.country,
            partner: this.state.partner,
            onboardingDate: this.state.onboardingDate === '' ? '1901-01-01' : this.state.onboardingDate.toUTCString(),
            billingDate: this.state.billingDate === '' ? '1901-01-01' : this.state.billingDate.toUTCString(),
            trainingDate: this.state.trainingDate === '' ? '1901-01-01' : this.state.trainingDate.toUTCString(),
            supportNotes: this.state.supportNotes,
            systemId: this.state.systemId,
            partnerContract: this.state.partnerContract,
            support: this.state.support,
            bots: this.state.bots,
            keyManagementType: this.state.keyManagementType,
            keyManagement: {
                rotationType: this.state.rotationType,
                intervalDays: parseInt(this.state.intervalDays),
                activationDelay: parseInt(this.state.activationDelay),
                willExpire: this.state.willExpire ? "Yes" : "No",
                expireDays: parseInt(tmpExpireDays),
                keySecurity: this.state.keySecurity,
                customEncryptionKeyVaultUrl: this.state.customEncryptionKeyVaultUrl,
                customEncryptionKeySecretName: this.state.customEncryptionKeySecretName,
                asymmetricKeyEnabled: this.state.asymmetricKeyEnabled,
                asymmetricKeySettings: {
                    keyType: this.state.keyType,
                    keySetting: this.state.keySetting,
                    asymmetricKeyFileName: this.state.asymmetricKeyFileName
                },
            },
            packageImport: this.state.packageImport,
            tenantSuspensionConvDelProcess: this.state.tenantSuspensionConvDelProcess,
            awsAccessKeyId: this.state.awsAccessKeyId,
            awsSecretAccess: this.state.awsSecretAccess,
            awsBucketName: this.state.awsBucketName,
            awsRegion: this.state.awsRegion,
            awsServiceUrl: this.state.awsServiceUrl,
            awsType: this.state.awsType,
            chatModelA: this.state.chatModelA,
            showTicketPage: this.state.showTicketPage
        };
        if (this.props.data != null) {
            var data = await apol
                .mutate({
                    mutation: mutationUpdateTenant,
                    refetchQueries: [{
                        query: queryGetTenantList,
                        variables: { auth: this.props.authorization },
                    }],
                    variables: {
                        auth: this.props.authorization,
                        tenant: tenant
                    }
                });
            if (data.data.updateTenant == null || data.data.updateTenant.name === "error") {
                toast.info(<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "changeTenantNotSuccessful")}</>)}</MyContext.Consumer>, {
                    position: "bottom-left",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                });
            } else {
                toast.info(<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "tenantChanged")}</>)}</MyContext.Consumer>, {
                    position: "bottom-left",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                });
            }
        } else {
            data = await apol
                .mutate({
                    mutation: mutationCreateTenant,
                    refetchQueries: [{
                        query: queryGetTenantList,
                        variables: { auth: this.props.authorization },
                    }],
                    variables: {
                        auth: this.props.authorization,
                        tenant: tenant
                    }
                });
            if (data.data.createTenant == null || data.data.createTenant.name === "error") {
                toast.info(<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "addTenantNotSuccessful")}</>)}</MyContext.Consumer>, {
                    position: "bottom-left",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                });
            } else {
                toast.info(<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "tenantAdded")}</>)}</MyContext.Consumer>, {
                    position: "bottom-left",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                });
            }
        }
    };

    openExportSettings = () => {
        return <ExportConfig cl={this._onDismissExportPanel} />
    }

    _onDismissExportPanel() {
        this.setState({ showExportPanel: false });
    }

    _onOpenExportPanel() {
        this.setState({ showExportPanel: true });
    }

    openImportSettings = () => {
        return <ImportConfig cl={this._onDismissImportPanel} />

    }
    _onDismissImportPanel() {
        this.setState({ showImportPanel: false });
    }
    _onOpenImportPanel() {
        this.setState({ showImportPanel: true });
    }
    openAudioStorageSettings = (audioStorage, storage) => {
        return <AudioStorageConfig tenantId={this.state.tenantId} apol={this.props.apol} authorization={this.props.authorization} data={audioStorage} cl={this._onDismissAudioStoragePanel} storageType={storage} packageArchive={this.state.packageArchive} />

    }
    _onDismissAudioStoragePanel() {
        this.setState({ showAudioStoragePanel: false });
    }
    _onOpenAudioStoragePanel() {
        this.setState({ showAudioStoragePanel: true });
    }
    openBotOnboardingSettings = () => {
        return <BotOnboardingConfig tenantId={this.state.tenantId} apol={this.props.apol} cl={this._onDismissBotOnboardingPanel} />
    }
    _onDismissBotOnboardingPanel() {
        this.setState({ showBotOnboardingPanel: false });
    }
    _onOpenBotOnboardingPanel() {
        this.setState({ showBotOnboardingPanel: true });
    }
    _closeModal = () => {
        this.setState({ showModal: false });
    }

    _openModal = () => {
        this.setState({ showModal: true });
    }

}
function accessOption(rule) {
    let out = [];
    let tmp = [];
    for (let i = 0; i < rule.length; i++) {
        if ((rule[i].group === "access"))//filter the Rule Type
        {
            tmp.push(rule[i]);
        }
    }
    switch (tmp) {
        case 0: out.push({ key: "no Rule", text: "no Rule", disabled: true }); break;
        case 1: out.push({ key: tmp[0].id, text: tmp[0].name, disabled: true }); break;
        default:
            out.push({ key: 'Header', text: 'Access Rules', itemType: DropdownMenuItemType.Header });
            for (let i = 0; i < tmp.length; i++) {
                out.push({ key: tmp[i].id, text: tmp[i].name });
            }
            break;
    }
    return out;
}
function analyticsOption(rule) {
    let out = [];
    let tmp = [];
    for (let i = 0; i < rule.length; i++) {
        if ((rule[i].group === "analytics"))//filter the Rule Type
        {
            tmp.push(rule[i]);
        }
    }
    switch (tmp) {
        case 0: out.push({ key: "no Rule", text: "no Rule", disabled: true }); break;
        case 1: out.push({ key: tmp[0].id, text: tmp[0].name, disabled: true }); break;
        default:
            out.push({ key: 'Header', text: 'Analytic Rules', itemType: DropdownMenuItemType.Header });
            for (let i = 0; i < tmp.length; i++) {
                out.push({ key: tmp[i].id, text: tmp[i].name, title: tmp[i].usage });
            }
            break;
    }
    return out;
} function recordingOption(rule) {
    let out = [];
    let tmp = [];
    if (rule != null) {
        for (let i = 0; i < rule.length; i++) {
            if ((rule[i].group === "recording"))//filter the Rule Type
            {
                tmp.push(rule[i]);
            }
        }
    }
    switch (tmp) {
        case 0: out.push({ key: "no Rule", text: "no Rule", disabled: true }); break;
        case 1: out.push({ key: tmp[0].id, text: tmp[0].name, disabled: true }); break;
        default:
            out.push({ key: 'Header', text: 'Recording Rules', itemType: DropdownMenuItemType.Header });
            for (let i = 0; i < tmp.length; i++) {
                out.push({ key: tmp[i].id, text: tmp[i].name, title: tmp[i].usage });
            }
            break;
    }
    return out;
} function replayOption(rule) {
    let out = [];
    let tmp = [];
    for (let i = 0; i < rule.length; i++) {
        if ((rule[i].group === "replay"))//filter the Rule Type
        {
            tmp.push(rule[i]);
        }

    }
    switch (tmp) {
        case 0: out.push({ key: "no Rule", text: "no Rule", disabled: true }); break;
        case 1: out.push({ key: tmp[0].id, text: tmp[0].name, disabled: true }); break;
        default:
            out.push({ key: 'Header', text: 'Replay Rules', itemType: DropdownMenuItemType.Header });
            for (let i = 0; i < tmp.length; i++) {
                out.push({ key: tmp[i].id, text: tmp[i].name, title: tmp[i].usage });
            }
            break;
    }
    return out;
}